import axios from 'axios';
import { Route } from 'vue-router';

export default {
  setVhProperty(): void {
    _setVh();
    window.addEventListener('resize', () => {
      _setVh();
    });
  },

  setCsrfTokenHeader() {
    let element = document.querySelector("meta[name='csrf-token']")
    let token = element ? element.getAttribute('content') : null

    if (token) {
      axios.defaults.headers.common['X-CSRF-Token'] = token
    }
  },

  setDocumentTitle(val: Route, $tr: any, store: any) {
    if(val.name === 'registration') {
      return;
    }
    store.commit('updatePageStatus', null)
    let title = $tr('pageTitles.prefix')

    if (val && val.meta && val.meta.title) {
      let routeTitle = $tr(val.meta.title)
      title = `${routeTitle} - ${title}`
    }
    document.title = title
  }
}

function _setVh() {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}